import React, { useState, useEffect } from 'react'
import { AppBar, Toolbar, Typography, Button, Box, CircularProgress } from '@material-ui/core'

import { useStyles } from './styles'

const pdfUrl =
  'https://www.puntacarretas.com.uy/uploads/attachs/202508/20250806170006_2133145075.pdf'

const Terms = () => {
  const classes = useStyles()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  const handleIframeLoad = () => {
    setIsLoading(false)
  }

  const handleIframeError = () => {
    setError('No se pudo cargar el PDF. Intenta abrirlo en una nueva pestaña.')
    setIsLoading(false)
  }

  const handleOpenInNewTab = () => {
    window.open(pdfUrl, '_blank')
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" elevation={0} className={classes.appBar}>
        <Toolbar>
          <div className={classes.title}>
            <Typography variant="h6">Política de Privacidad</Typography>
            <Typography variant="body2">Visualización directa del documento PDF</Typography>
          </div>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={handleOpenInNewTab}
          >
            Abrir en nueva pestaña
          </Button>
        </Toolbar>
      </AppBar>

      <Box position="relative" bgcolor="grey.200">
        {isLoading && (
          <div className={classes.overlay}>
            <CircularProgress color="primary" />
            <Typography variant="body2">
              Si no carga en unos segundos, usa Abrir en nueva pestaña
            </Typography>
          </div>
        )}

        {error && (
          <div className={classes.overlay}>
            <Typography className={classes.errorIcon}>
              <span role="img" aria-label="warning">
                ⚠️
              </span>
            </Typography>
            <Typography variant="body1" color="textPrimary" gutterBottom>
              {error}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={handleOpenInNewTab}
            >
              Abrir en nueva pestaña
            </Button>
          </div>
        )}

        <iframe
          src={pdfUrl}
          className={classes.iframe}
          onLoad={handleIframeLoad}
          onError={handleIframeError}
          title="Política de Privacidad PDF"
        />
      </Box>
    </div>
  )
}

export { Terms }
